import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { useFunnelGraphOption } from "./options"

type useFunnelGraphEventsProps<T> = {
	graphOption: ReturnType<typeof useFunnelGraphOption<T>>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const useFunnelGraphEvents = <T,>({
	graphOption: {
		axisDef,
    inverse
	},
	onChangeCondition
}: useFunnelGraphEventsProps<T>) => {
  const onClickAera = useCallback(
    (params: {
      event?: { event?: { ctrlKey?: boolean } },
      data?: { code: string, name: string }
    }) => {
      const data = params?.data
      if (!data) return
      onChangeCondition(
				axisDef?.key,
				{
          code: [data.code],
          label: data.name,
          ...(params?.event?.event?.ctrlKey ? {
            over: false,
            under: false
          } : inverse ? {
            under: true
          } : {
            over: true
          })
        }
			)
    },
    [axisDef, inverse, onChangeCondition]
  )
	return {
		click: onClickAera
	}
}